/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Modal,
  Table,
  FlexboxGrid,
  AutoComplete,
  IconButton,
  Checkbox,
  Button,
  SelectPicker,
} from 'rsuite';
import { Edit, Copy } from '@rsuite/icons';
import { toast } from 'react-toastify';
import { format, parseISO } from 'date-fns';
import api from '~/services/api';
import useSearchNames from '~/services/useSearchNames';
import EditarPedido from '../../../Pedidos/EditarPedido';

const { HeaderCell, Column, Cell } = Table;

function ModalPedidosDisponiveis({ exibir, onFechar, profissional }) {
  const [pedidos, setPedidos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [cidadeSelecionada, setCidadeSelecionada] = useState();
  const [nomesCidades, setNomesCidades] = useState([]);
  const [pedidoEditando, setPedidoEditando] = useState();
  const [pedidoEditandoId, setPedidoEditandoId] = useState();
  const [showEditarPedido, setShowEditarPedido] = useState(false);
  const [pedidosSelecionados, setPedidosSelecionados] = useState([]);
  const [filtroServico, setFiltroServico] = useState();
  const [profissoes, setProfissoes] = useState([]);

  const buscarNomesCidades = useSearchNames(
    setNomesCidades,
    'cidades',
    setCidadeSelecionada
  );

  const buscarPedidos = useCallback(async () => {
    if (!profissional || !exibir) return;

    setCarregando(true);
    try {
      const resposta = await api.get('pedidos-disponiveis-emergencia', {
        params: {
          uf: profissional.uf,
          idCidade: cidadeSelecionada,
          filtroServico,
        },
      });

      const lista = resposta.data.lista.map((pedido) => ({
        ...pedido,
        data: format(parseISO(pedido.data), 'dd/MM/yyyy'),
        hora_inicio: format(new Date(pedido.hora_inicio), 'HH:mm'),
        hora_fim: format(new Date(pedido.hora_fim), 'HH:mm'),
        tarifa_repasse: pedido.tarifa_repasse,
      }));

      setPedidos(lista);
    } catch (e) {
      toast.error(e.message);
    }
    setCarregando(false);
  }, [profissional, exibir, cidadeSelecionada, filtroServico]);

  useEffect(() => {
    const buscarDadosApi = async () => {
      try {
        const resposta = await api.get('profissao');
        setProfissoes(resposta.data);
      } catch (error) {
        toast.error(error.message);
      }
    };

    buscarDadosApi();
  }, []);

  useEffect(() => {
    if (exibir) {
      buscarPedidos();
    }
  }, [buscarPedidos, exibir]);

  useEffect(() => {
    setPedidosSelecionados([]);
  }, [pedidos]);

  const handleFechar = () => {
    setPedidos([]);
    setCidadeSelecionada(null);
    setPedidosSelecionados([]);
    setFiltroServico(null);
    onFechar();
  };

  function abrirEditarPedido(pedido) {
    setPedidoEditando(pedido);
    setPedidoEditandoId(pedido.id);
    setShowEditarPedido(true);
  }

  function fecharEditarPedido() {
    setPedidoEditandoId();
    buscarPedidos();
    setShowEditarPedido(false);
  }

  const handleSelecionarTodos = (checked) => {
    if (checked) {
      setPedidosSelecionados(pedidos.map((p) => p.id));
    } else {
      setPedidosSelecionados([]);
    }
  };

  const handleSelecionarPedido = (pedidoId, checked) => {
    if (checked) {
      setPedidosSelecionados([...pedidosSelecionados, pedidoId]);
    } else {
      setPedidosSelecionados(
        pedidosSelecionados.filter((id) => id !== pedidoId)
      );
    }
  };

  const formatarParaWhatsApp = (pedido) => {
    const horario = `${pedido.hora_inicio} - ${pedido.hora_fim}`;
    const valorFormatado = pedido.tarifa_repasse
      ? `R$ ${parseFloat(pedido.tarifa_repasse).toFixed(2)}`
      : 'Não informado';
    const funcao = pedido.profissao || 'Não informado';
    const bairro = pedido.bairro || 'Não informado';

    return `*Nome do Estabelecimento*: ${pedido.nome_fantasia}\n*Função*: ${funcao}\n*Horário*: ${horario}\n*Dia*: ${pedido.data}\n*Cidade*: ${pedido.cidade}\n*Bairro*: ${bairro}\n*Valor de repasse*: ${valorFormatado}`;
  };

  const copiarSelecionados = async () => {
    if (pedidosSelecionados.length === 0) {
      toast.warning('Selecione pelo menos um pedido');
      return;
    }

    const pedidosParaCopiar = pedidos.filter((p) =>
      pedidosSelecionados.includes(p.id)
    );

    const textoFormatado = pedidosParaCopiar
      .map((pedido, index) => formatarParaWhatsApp(pedido))
      .join('\n\n------------------------\n\n');

    try {
      await navigator.clipboard.writeText(textoFormatado);
      toast.success(
        `${pedidosSelecionados.length} ${
          pedidosSelecionados.length === 1
            ? 'pedido copiado'
            : 'pedidos copiados'
        } para a área de transferência`
      );
    } catch (error) {
      toast.error('Erro ao copiar para área de transferência');
    }
  };

  return (
    <Modal open={exibir} onClose={handleFechar} size="lg" overflow>
      <Modal.Header>
        <Modal.Title>
          Pedidos Disponíveis - {profissional && profissional.nome}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FlexboxGrid
          justify="start"
          style={{ marginBottom: '20px', gap: '10px' }}
        >
          <AutoComplete
            name="cidades"
            style={{ width: '250px' }}
            data={nomesCidades.map((c) => ({
              label: c.cidade,
              value: c.cidade,
              id: c.id,
            }))}
            placeholder="Filtrar por Cidade"
            onSelect={async (value, item) => {
              setCidadeSelecionada(item.id);
            }}
            onChange={(value) => {
              if (!value) setCidadeSelecionada(null);
              buscarNomesCidades(value);
            }}
          />
          <SelectPicker
            name="id_profissao"
            placeholder="Serviço"
            value={filtroServico}
            data={profissoes.map((p) => {
              return {
                label: p.profissao,
                value: p.id,
              };
            })}
            onChange={setFiltroServico}
          />
          <Button
            appearance="primary"
            startIcon={<Copy />}
            onClick={copiarSelecionados}
            disabled={pedidosSelecionados.length === 0}
          >
            Copiar Selecionados ({pedidosSelecionados.length})
          </Button>
        </FlexboxGrid>

        <Table
          height={400}
          data={pedidos}
          loading={carregando}
          bordered
          cellBordered
        >
          <Column width={50} fixed align="center">
            <HeaderCell style={{ padding: '5px' }}>
              <Checkbox
                checked={
                  pedidos.length > 0 &&
                  pedidosSelecionados.length === pedidos.length
                }
                indeterminate={
                  pedidosSelecionados.length > 0 &&
                  pedidosSelecionados.length < pedidos.length
                }
                onChange={(value, checked) => handleSelecionarTodos(checked)}
              />
            </HeaderCell>
            <Cell style={{ padding: '5px' }} align="center">
              {(rowData) => (
                <Checkbox
                  checked={pedidosSelecionados.includes(rowData.id)}
                  onChange={(value, checked) =>
                    handleSelecionarPedido(rowData.id, checked)
                  }
                />
              )}
            </Cell>
          </Column>

          <Column width={60} fixed>
            <HeaderCell>Editar</HeaderCell>
            <Cell style={{ padding: '5px' }}>
              {(rowData) => (
                <IconButton
                  appearance="subtle"
                  onClick={() => abrirEditarPedido(rowData)}
                  icon={<Edit />}
                />
              )}
            </Cell>
          </Column>

          <Column width={120} resizable>
            <HeaderCell>Nº Pedido</HeaderCell>
            <Cell dataKey="numero_pedido" />
          </Column>

          <Column width={200} resizable>
            <HeaderCell>Cliente</HeaderCell>
            <Cell dataKey="nome_fantasia" />
          </Column>

          <Column width={140} resizable>
            <HeaderCell>Cidade</HeaderCell>
            <Cell dataKey="cidade" />
          </Column>

          <Column width={110} resizable>
            <HeaderCell>Data</HeaderCell>
            <Cell dataKey="data" />
          </Column>

          <Column width={75} resizable>
            <HeaderCell>Início</HeaderCell>
            <Cell dataKey="hora_inicio" />
          </Column>

          <Column width={75} resizable>
            <HeaderCell>Fim</HeaderCell>
            <Cell dataKey="hora_fim" />
          </Column>

          <Column width={150} resizable>
            <HeaderCell>Serviço</HeaderCell>
            <Cell dataKey="profissao" />
          </Column>

          <Column width={120} resizable>
            <HeaderCell>Valor Repasse</HeaderCell>
            <Cell>
              {(rowData) =>
                rowData.tarifa_repasse
                  ? `R$ ${parseFloat(rowData.tarifa_repasse).toFixed(2)}`
                  : '-'
              }
            </Cell>
          </Column>
        </Table>

        {pedidos.length === 0 && !carregando && (
          <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
            Nenhum pedido disponível no momento
          </div>
        )}
      </Modal.Body>

      <EditarPedido
        idPedido={pedidoEditandoId}
        showEditarPedido={showEditarPedido}
        codPedido={pedidoEditando && pedidoEditando.numero_pedido}
        setShowEditarPedido={setShowEditarPedido}
        fecharEditarPedido={fecharEditarPedido}
      />
    </Modal>
  );
}

export default ModalPedidosDisponiveis;
